module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/sacramento-ca.webp";